import { ModelBase } from '../../core/model/model-base';
import { PostTargetModel } from '../service/base/post-target-loader.interface';

export class Entrance extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.name = dataContext.name;
      this.id = dataContext.id;
      this.building = dataContext.building;
      this.code = dataContext.code;
    }
  }

  code: string;
  name: string;
  building: string;

  toString() {
    return this.code ? `${this.code} ${this.name}` : this.name;
  }
}

export class EntrancePostTarget extends ModelBase implements PostTargetModel {
  constructor(dataContext?: EntrancePostTarget) {
    super();
    if (dataContext) {
      this.id = dataContext.id || '';
      this.companyNumberName = dataContext.companyNumberName || '';
      this.propertyNumberName = dataContext.propertyNumberName || '';
      this.buildingNumberName = dataContext.buildingNumberName || '';
      this.entranceNumberName = dataContext.entranceNumberName || '';
    }
  }

  companyNumberName: string;
  propertyNumberName: string;
  buildingNumberName: string;
  entranceNumberName: string;

  postTargetDescription() {
    return {
      key: 'POST.POST_TARGET_DESCRIPTION.ENTRANCE',
      params: {
        companyName: this.companyNumberName,
        propertyName: this.propertyNumberName,
        buildingName: this.buildingNumberName,
        entranceName: this.entranceNumberName,
      },
    };
  }

  toAutocompleteValue(viewType: 'list' | 'field', culture?: string): string {
    switch (viewType) {
      case 'field':
      case 'list':
        return this.entranceNumberName;
    }
  }

  toString(culture?: string): string {
    return this.entranceNumberName;
  }
}
